// Lib
import { useEffect, useState } from 'react';

export interface WindowSize {
  width?: number;
  height?: number;
}

const useWindowSize = (): WindowSize => {
  function getSize(): WindowSize {
    if (typeof window === 'object') {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    }
    return {};
  }

  const [windowSize, setWindowSize] = useState<WindowSize>(getSize);
  useEffect(() => {
    function handleResize(): void {
      setWindowSize(getSize());
    }
    if (typeof window === 'object') {
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  return windowSize;
};

export default useWindowSize;
